import {useQuery} from 'react-query'
import {PaymentEditModalForm} from './PaymentEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getPaymentById} from '../core/_requests'

const PaymentEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: payment,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-payment-${itemIdForUpdate}`,
    () => {
      return getPaymentById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )
  if (!itemIdForUpdate) {
    return <PaymentEditModalForm isPaymentLoading={isLoading} payment={{id: undefined}} />
  }

  if (!isLoading && !error && payment) {
    console.log({payment, },"its payment")
    console.log(typeof payment,"its payment")
    return <PaymentEditModalForm isPaymentLoading={isLoading} payment={payment} />
  }

  return null
}

export {PaymentEditModalFormWrapper}
